module.exports = __webpack_public_path__ + "img/15.8f46232f.png";